
import type { Database } from "@/integrations/supabase/types";

type SubscriptionTier = Database['public']['Enums']['subscription_tier'];

export const getMaxResources = (tier: SubscriptionTier) => {
  const limits: Record<SubscriptionTier, number> = {
    free: 5,
    basic: 10,
    growth: 20,
    professional: 40,
    trainee: 0,
  };
  return limits[tier];
};
